module.exports = __webpack_public_path__ + "img/card2.a059b6a9.png";